<template>
    <div class="turn-counter">
        <div class="turn-counter-alert">
            <div class="buttons">
                <router-link
                tag="button"
                :to="{ name: '/' }"
                >
                <div class="btn btn-home">
                    <feather-icon
                    icon="HomeIcon"
                    size="16"
                    class="icon"
                    />
                    صفحه اصلی
                </div>
              </router-link >
            </div>
            <div class="alert-text">لطفا شماره موبایل مرتبط با نوبت خود را وارد نموده و دکمه تایید را فشار دهید.</div>
        </div>
        
        <div class="keyboard-num">
            <div class="keyboard">
            <button v-for="number in numbers" :key="number" @click="addNumber(number)">{{ number }}</button>
            <button class="editNum" @click="removeNum">تصحیح</button>
            </div>
            <div class="content-number">
                <input type="text" ref="input" maxlength="11" v-model="findPhone" />
                <div class="print-alert">
                    لطفا توجه فرمایید, امکان گرفتن قبض نوبت تنها در بازه زمانی نوبت که از طریق پیامک برای شما ارسال شده است, امکانپذیر می باشد.
                </div>
                <div class="confirmation" @click="confirmation">تایید</div>
            </div>
        </div>
        


        <Print
        v-if="showPrintTurn"
        :reserveFromTime="reserveFromTime"
        :reserveDate="reserveDate"
        :userName="userName"
        :doctorInfoProps="doctorInfoProps"
        :doctorInfo="doctorInfo"
        :unitId="unitId"
        @close="showPrintTurn = false"
    />
    </div>
</template>


<script>
import Print from "@/components/modal/PrintTurn.vue";
import moment from "jalali-moment";
export default {
    layout:'layoutFull',
  data() {
    return {
    findPhone: '',
      numbers: [1, 2, 3, 4, 5, 6, 7, 8, 9, 0],
      mobile:'',
      date:[],
      userName:'',
      reserveFromTime:'',
      reserveDate:'',
      doctorInfo:'',
      doctorInfoProps:{},
      unitId:'',
      showPrintTurn:false,
      index:0,
      statusRes:''

    };
  },
  components:{
    Print,
    moment
  },
  methods: {
    addNumber(number) {
      this.findPhone += number;
      this.$nextTick(() => this.$refs.input.focus())

    },
    removeNum(){
        if (this.findPhone.length > 0) {
        this.findPhone = this.findPhone.slice(0, -1);
        this.$nextTick(() => this.$refs.input.focus())
      }
    },
    confirmation(){
        let payload = {};
        this.mobile = this.findPhone;
        Object.assign(payload, { mobile: this.findPhone });

        this.$store
          .dispatch("user/searchUsers", payload)
          .then((res) => {
            const index=0
            const mobileUser = res[index].mobile
            this.date = res[index]._id
            this.statusRes = res[index].status
            if( this.mobile === mobileUser){
              this.doctorInfoProps = null;
                this.$store
                .dispatch("user/findUserToday",this.date)
                .then((response) => {
                this.doctorInfoProps=response;
                const doctorDate = moment(this.doctorInfoProps.date, 'YYYY-MM-DD').format('jYYYY-jM-jD');
                if(doctorDate && this.statusRes.includes('active')){
                    this.showPrintTurn= true
                  }
                this.doctorInfo =  this.doctorInfoProps.planUserId.firstName + " " +  this.doctorInfoProps.planUserId.lastName
                this.unitId=  this.doctorInfoProps.unitId.title

                const date= moment(this.doctorInfoProps.date, "YYYY-MM-DD");
                const formattedDate= date.format("jYYYY-jMM-jDD");
                this.reserveDate =  formattedDate
                
                this.doctorInfoProps.times.forEach(time => {
                  const matchingTurn = time.turns.find(item => item.turnUserId._id === this.date);
                  if (matchingTurn) {
                    this.reserveFromTime = time.fromTime;
                    this.userName = matchingTurn.turnUserId.firstName + " " +  matchingTurn.turnUserId.lastName

                  }
                });
             });     

            }

          })
    }
  },
  mounted(){
    this.$nextTick(() => this.$refs.input.focus())
  }
};
</script>
